import Calendar from './calendar.png';
import PaperclipIcon from './paperclip.png';
import UserIcon from './user.png';
import ArrowLeft from './arrow-left.png';
import LockIcon from './lock.png';
import PasswordInactive from './password-inactive.png';
import PasswordActive from './password-active.png';
import LogoutIcon from './logout.png';
import ProfileIcon from './profile.png';
import DownloadIcon from './download.png';
import EditIcon from './edit.png';
import AddIcon from './add.png';
import SearchIcon from './search.png';
import TrashIcon from './trash.png';
import ArrowUp from './arrow-up.png';
import ArrowBottom from './arrow-bottom.png';
import ViewIcon from './view.png';
import MailIcon from './mail.png';
import TimeIcon from './time.png';
import ArrowBottomBlack from './arrow-bottom-black.png';
import ArrowUpBlack from './arrow-up-black.png';
import CalendarWhite from './calendar-white.png';
import DeleteIcon from './delete.png';
import CalendarRed from './calendar-red.png';
import CloseIcon from './close.png';
import CheckGreenIcon from './check-green.png';
import MenuIcon from './menu.png';
import LogoutGray from './logout-gray.png';
import ArrowLeft2 from './arrow-left2.png';
import LocationIcon from './location.png';
import PhoneIcon from './phone.png';
import FacebookIcon from './facebook.png';
import InstagramIcon from './instagram.png';
import WebIcon from './web.png';
import CleanIcon from './clean.png';
import ArrowRight from './arrow-right.png';
import UploadIcon from './upload.png';
import ArrowLeftBlack from './arrow-left-black.png';
import ArrowRightBlack from './arrow-right-black.png';
import CheckWhiteIcon from './check-white.png';
import StarIcon from './star.png';
import StarActiveIcon from './star-active.png';
import XLSIcon from './xls.png';
import Download2Icon from './download2.png';
import Upload2Icon from './upload2.png';
import EyeBlackIcon from './eye-black.png';
import DownloadBlackIcon from './download-black.png';
import AlertIcon from './alert.png';
import ModeratorIcon from './moderator.png';
import EditBlueIcon from './edit-blue.png';
import PrintIcon from './print.png';
import AssignIcon from './assign.png';
import IconUsers from './icon-users.png';
import UserSettings from './user-settings.png';
import DownloadExcelIcon from './download-excel.png';
import GoogleMapsIcon from './google-maps.png';
import PercentageIcon from './percentage.png';
import BankIcon from './bank.png';
import ListIcon from './list.png';
import PaymentIcon from './payments.png';
import DocumentIcon from './documents.png';
import CodingIcon from './coding.png';
import CopyIcon from './copy.png';
import CaretIcon from './caret.png';
import MenuOpenIcon from './menu-open.png';
import MenuCloseIcon from './menu-close.png';
import Home1Icon from './home1.png';
import Home2Icon from './home2.png';
import Home3Icon from './home3.png';
import Home4Icon from './home4.png';
import Messages1Icon from './messages1.png';
import Messages2Icon from './messages2.png';
import Messages3Icon from './messages3.png';
import SandClockIcon from './sand-clock.png';
import CampaignUserIcon from './campaign-users.png';
import CampaignListIcon from './campaign-list.png';
import CampaignTitleIcon from './campaign-title.png';
import UserListIcon from './user-list.png';
import IdCardIcon from './id-card.png';
import CheckUserIcon from './check-user.png';
import FaceIcon from './face.png';
import VerificationManualIcon from './verification-manual.png';
import FaceIdentityIcon from './face-identity.png';
import SalarymanIcon from './salaryman.png';
import BlackListIcon from './black-list.png';
import BlackListRedIcon from './black-list-red.png';
import CheckGreenCircle from './check-circle-green.png';
import CloseRedIcon from './close-red.png';
import WhatsappIcon from './whatsapp.png';
import TiktokIcon from './tiktok.png';
import CompanyIcon from './company.png';
import MessageIcon from './message.png';
import RestrictionIcon from './restrictions.png';
import ApiIcon from './api.png';
import WarningIcon from './warning.png';
import SendIcon from './send.png';
import LoadingGif from './loading.gif';
import WhatsappSquareIcon from './whatsapp-square.png';
import FacebookSquareIcon from './facebook-square.png';
import InstagramSquareIcon from './instagram-square.png';
import ApiSquareIcon from './api-square.png';
import TiktokSquareIcon from './tiktok-square.png';
import ChatCircleIcon from './chat-circle.png';
import SettingsIcon from './settings.png';
import GoogleCalendarIcon from './google-calendar.png';
import InfoIcon from './info.png';
import InstagramIcon2 from './instagram-icon.png';
import FacebookMessengerIcon2 from './facebook-messenger-icon.png';
import GoogleCalendarIcon2 from './google-calendar-icon.png';
import WhatsappIcon2 from './whatsapp-icon.png';
import ApiIcon2 from './api-icon.png';

import Menu1 from './menu/menu1.png';
import Menu2 from './menu/menu2.png';
import Menu3 from './menu/menu3.png';
import Menu4 from './menu/menu4.png';
import Menu5 from './menu/menu5.png';
import Menu6 from './menu/menu6.png';
import Menu7 from './menu/menu7.png';
import Menu8 from './menu/menu8.png';
import Menu9 from './menu/menu9.png';
import Menu10 from './menu/menu10.png';

import Actions1 from './menu/actions-1.png';
import Actions2 from './menu/actions-2.png';
import Actions3 from './menu/actions-3.png';
import Actions4 from './menu/actions-4.png';

import Information1 from './menu/information1.png';
import Information2 from './menu/information2.png';
import Information3 from './menu/information3.png';
import Information4 from './menu/information4.png';
import Information5 from './menu/information5.png';
import Information6 from './menu/information6.png';

import AgentIcon1 from './menu/agent1.png';
import AgentIcon2 from './menu/agent2.png';
import AgentIcon3 from './menu/agent3.png';
import AgentIcon4 from './menu/agent4.png';

const Menu = {
	Menu1,
	Menu2,
	Menu3,
	Menu4,
	Menu5,
	Menu6,
	Menu7,
	Menu8,
	Menu9,
	Menu10,
	Actions1,
	Actions2,
	Actions3,
	Actions4,
	Information1,
	Information2,
	Information3,
	Information4,
	Information5,
	Information6,
	AgentIcon1,
	AgentIcon2,
	AgentIcon3,
	AgentIcon4
}

export {
	Calendar,
	ArrowLeft,
	PaperclipIcon,
	UserIcon,
	LockIcon,
	PasswordInactive,
	PasswordActive,
	LogoutIcon,
	ProfileIcon,
	DownloadIcon,
	EditIcon,
	AddIcon,
	SearchIcon,
	TrashIcon,
	ArrowUp,
	ArrowBottom,
	ViewIcon,
	MailIcon,
	TimeIcon,
	ArrowBottomBlack,
	ArrowUpBlack,
	CalendarWhite,
	DeleteIcon,
	CalendarRed,
	CloseIcon,
	CheckGreenIcon,
	Menu,
	MenuIcon,
	LogoutGray,
	ArrowLeft2,
	LocationIcon,
	WebIcon,
	InstagramIcon,
	FacebookIcon,
	PhoneIcon,
	CleanIcon,
	ArrowRight,
	UploadIcon,
	ArrowLeftBlack,
	ArrowRightBlack,
	CheckWhiteIcon,
	StarActiveIcon,
	StarIcon,
	XLSIcon,
	Download2Icon,
	EyeBlackIcon,
	DownloadBlackIcon,
	AlertIcon,
	ModeratorIcon,
	EditBlueIcon,
	PrintIcon,
	AssignIcon,
	IconUsers,
	UserSettings,
	DownloadExcelIcon,
	GoogleMapsIcon,
	PercentageIcon,
	BankIcon,
	PaymentIcon,
	ListIcon,
	DocumentIcon,
	CodingIcon,
	CopyIcon,
	CaretIcon,
	MenuOpenIcon,
	MenuCloseIcon,
	Home1Icon,
	Home2Icon,
	Home3Icon,
	Home4Icon,
	Messages1Icon,
	Messages2Icon,
	Messages3Icon,
	SandClockIcon,
	CampaignUserIcon,
	CampaignListIcon,
	CampaignTitleIcon,
	UserListIcon,
	FaceIcon,
	CheckUserIcon,
	IdCardIcon,
	VerificationManualIcon,
	FaceIdentityIcon,
	SalarymanIcon,
	BlackListIcon,
	BlackListRedIcon,
	CloseRedIcon,
	CheckGreenCircle,
	Upload2Icon,
	WhatsappIcon,
	CompanyIcon,
	MessageIcon,
	ApiIcon,
	RestrictionIcon,
	WarningIcon,
	SendIcon,
	LoadingGif,
	TiktokIcon,
	WhatsappSquareIcon,
	ApiSquareIcon,
	InstagramSquareIcon,
	FacebookSquareIcon,
	TiktokSquareIcon,
	ChatCircleIcon,
	SettingsIcon,
	GoogleCalendarIcon,
	InfoIcon,
	InstagramIcon2,
	FacebookMessengerIcon2,
	WhatsappIcon2,
	GoogleCalendarIcon2,
	ApiIcon2
}